import React, { useContext } from 'react'
import PropTypes from 'prop-types'

// component stack
import * as Styled from './Filter.styles'
import * as Component from 'components/molecules/Modal/Modal.styles'
import Icon from 'components/atoms/Icon/Icon'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'
import { useMobileSwitch } from 'hooks'

const Filter = ({
  onReset,
  children,
  isFilterFullscreen,
  closeFilter,
  onClickSearchBtn,
  isLoading,
  isFilterSet,
  ...rest
}) => {
  const textContext = useContext(TextContext)
  const isMobile = useMobileSwitch()

  return (
    <Styled.Container isMobile={ isMobile } { ...rest }>
      <Styled.Header>
        <div className='h4' style={{ marginBottom: 0 }}>
          {isMobile
            ? textContext['filter.main.mobile']
            : textContext['filter.main.desktop']}
        </div>
        {isFilterFullscreen && (
          <Component.CloseModal
            data-cy='modal-close-filters'
            isLoading={ isLoading }
            onClick={ () => closeFilter() }>
            <Icon className='icon-f-cross' />
          </Component.CloseModal>
        )}
        {!isFilterFullscreen && isFilterSet && (
          <button
            id='filter-reset-btn'
            onClick={ () => onReset() }
            className='btn btn-link'
            type='button'
            data-filter-reset=''
            style={{ color: '#303030' }}>
            {textContext['filter.link.reset']}
          </button>
        )}
      </Styled.Header>
      <Styled.Body data-filter-body isMobile={ isMobile }>
        {false !== children && children}
        {isFilterFullscreen && (
          <Styled.BtnWrapper>
            <Styled.FilterButton
              id='filter-button'
              ariaLabel='Filter anwenden'
              text={ textContext['filter.btn.mobile'] }
              handleFilterSelect
              onClick={ () => onClickSearchBtn() }
              tabIndex='-1'
            />
          </Styled.BtnWrapper>
        )}
      </Styled.Body>
    </Styled.Container>
  )
}

Filter.defaultProps = {
  children: false,
  onClickSearchBtn: false,
}

Filter.propTypes = {
  /** handler for reset **/
  onReset: PropTypes.func.isRequired,
  /** generic children **/
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
  /** flag for render in mobile mode (only on mobile devices) **/
  isFilterFullscreen: PropTypes.bool,
  /** flag for render map in fullScreen **/
  closeFilter: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  /** trigger search xht into parent **/
  onClickSearchBtn: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  /** flag for xhr pending **/
  isLoading: PropTypes.bool,
  /** flag for hiding reset */
  isFilterSet: PropTypes.bool,
}

export default Filter
